import { ConsoleLogger, Tracker } from '@dpdgroupuk/react-event-tracker';

// TODO - Uncomment and configure the analytics service
// import { analytics } from '../services/firebase';
//
// export const tracker = new Tracker({
//   projectRef: 'ROUT',
//   analytics:
//     process.env.NODE_ENV === 'development' ||
//     `${process.env.REACT_APP_SENTRY_ENV}`.toLowerCase().includes('dev')
//       ? ConsoleLogger
//       : analytics,
// });

export const tracker = new Tracker({
  projectRef: 'ROUT',
  analytics: ConsoleLogger,
});
